import Vue from 'vue'

// axios
import axios from 'axios'

// Função para extrair o subdomínio
function getSubdomain() {
  const host = window.location.hostname // ex: tenant1.localhost
  const parts = host.split('.')
  // Considera subdomínio se houver pelo menos 2 partes (tenant1.localhost) ou mais
  if (parts.length >= 2) {
    return parts[0]
  }
  return null
}

// Flag de multi-tenant (espera "true" ou "false" na .env)
const isMultiTenant = process.env.VUE_APP_MULTI_TENANT === 'true'

// Só calcula subdomínio quando multi-tenant está habilitado
const subdomain = isMultiTenant ? (getSubdomain() || 'hub') : null

// Detecta se está no contexto "portal-cliente"
const isPortalCliente = window.location.href.indexOf('portal-cliente') >= 0

// Lê base da env
const rawApiBase = process.env.VUE_APP_API_BASE_URL || ''

let apiBaseUrl = rawApiBase

if (isMultiTenant) {
  // Se o base tiver "hub." substitui por "<subdomain>."
  if (rawApiBase.includes('hub.')) {
    apiBaseUrl = rawApiBase.replace('hub.', `${subdomain}.`)
  } else {
    // Tenta ajustar hostname quando URL for localhost (ex: https://localhost:44302 -> https://tenant1.localhost:44302)
    try {
      const u = new URL(rawApiBase)
      if (u.hostname === 'localhost' && subdomain && subdomain !== 'hub') {
        u.hostname = `${subdomain}.localhost`
      }
      apiBaseUrl = u.toString().replace(/\/$/, '')
    } catch (e) {
      // fallback: usa raw
      apiBaseUrl = rawApiBase
    }
  }
} else {
  // multi-tenant desabilitado -> usa base exatamente como está na env
  apiBaseUrl = rawApiBase.replace(/\/$/, '')
}

// Configura a baseURL dinamicamente com variáveis de ambiente
const axiosIns = axios.create({
  baseURL: `${apiBaseUrl}/api${isPortalCliente ? process.env.VUE_APP_PORTAL_CLIENTE : ''}`,
})

axiosIns.interceptors.request.use(config => {
  Vue.prototype.$Progress.start()
  return config
}, error => {
  Vue.prototype.$Progress.fail()
  return Promise.reject(error)
})

axiosIns.interceptors.response.use(response => {
  Vue.prototype.$Progress.finish()
  return response
}, error => {
  Vue.prototype.$Progress.fail()
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('userData')
    // Detecta se é portal do cliente pelo endereço
    if (isPortalCliente) {
      window.location.href = `${window.location.origin}/portal-cliente/login`
    } else {
      window.location.href = `${window.location.origin}/login`
    }
    return Promise.reject(error)
  }
  return Promise.reject(error)
})

Vue.prototype.$http = axiosIns

export default axiosIns
